import './LoginForm.css';

import Error from 'components/alerts/Error';
import { Card } from 'components/common/card/Card';
import { DataValidator } from 'components/validation/data/DataValidator';
import { Padding } from 'lib/styles/Padding';
import { defaultLoadTransition } from 'lib/styles/Transitions';
import cloneDeep from 'lodash/cloneDeep';
import ForgotPasswordForm from 'pages/auth/login/components/login-form/ForgotPassword';
import * as React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withCookies } from 'react-cookie';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin } from 'react-google-login';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { AuthenticationService } from 'services/api/Authentication.service';
import UserDucks from 'stores/ducks/User.duck';
import * as yup from 'yup';


interface ILoginFormState {
  password: {
    username: string;
    password: string;
  };
  facebook: {
    name?: string | null;
    accessToken?: string | null;
    clicked: boolean;
  };
  isValid: boolean;
  error: boolean;
  changePassword: boolean;
}

interface IProps {
  isLoggedIn?: boolean;
  isLoading?: boolean;
  dispatch?: any;
  cookies?: any;
}

/**
 * The form that is used for login. Also handles the forgot password functionality.
 */
class LoginForm extends React.Component<IProps, ILoginFormState> {

  public state: ILoginFormState = {
    password: {
      username: "",
      password: ""
    },
    facebook: {
      name: null,
      accessToken: null,
      clicked: false
    },
    isValid: true,
    error: false,
    changePassword: false
  };

  private AuthService = new AuthenticationService();

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFacebookCallback = this.handleFacebookCallback.bind(this);
    this.handleGoogleCallback = this.handleGoogleCallback.bind(this);
    this.handleFacebookContinueAsClick = this.handleFacebookContinueAsClick.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
  }

  public componentWillUnmount() {
    this.setLoading(false);
  }

  public handleChangeInput(e: any) {
    const { state } = this;
    const { password } = this.state;
    this.setState({
      ...state,
      password: {
        ...password,
        [e.target.name]: e.target.value
      }
    });
  }

  public handleSuccess() {
    return true;
  }

  public handleError() {
    return false;
  }

  public handleSubmit(e: any) {
    e.preventDefault();
    const { username, password } = this.state.password;
    this.setLoading(true);
    this.AuthService.authWithPassword(username.toLowerCase(), password)
      .catch(ee => {
        this.setLoading(false);
        this.setState({ ...this.state, error: true })
        return ee;
      })
      .then((res: any) => {

        if (res.token === undefined) {
          this.setLoading(false);
          this.setState({ ...this.state, error: true })
          return false;
        }

        const newRes = cloneDeep(res);
        delete newRes.events;
        this.props.dispatch(UserDucks.setUser(res));
        // Removing old cookies
        this.props.cookies.remove("user", { path: "/" });
        this.props.cookies.remove("token", { path: "/" });
        // Putting new cookies
        const date = new Date(); date.setDate(date.getDate() + 7);
        this.props.cookies.set("user", newRes, { path: "/", expires: date });
        this.props.cookies.set("token", res.token, { path: "/", expires: date });
        return true;

      });
    return null;
  }

  public forgotPassword() {
    this.setState({ changePassword: true })
  }

  public async handleFacebookCallback(res) {
    const responseJson = await this.AuthService.authWithFaceboook(
      res.accessToken
    );
    if (this.state.facebook.clicked === true) {
      const newRes = cloneDeep(responseJson);
      delete newRes.events;
      this.props.dispatch(UserDucks.setUser(responseJson));
      // Removing old cookies
      this.props.cookies.remove("user", { path: "/" });
      this.props.cookies.remove("token", { path: "/" });
      // Putting new cookies
      const date = new Date(); date.setDate(date.getDate() + 7);
      this.props.cookies.set("user", newRes, { path: "/", expires: date });
      this.props.cookies.set("token", newRes.token, { path: "/", expires: date });
    } else {
      if (responseJson.fullname) {
        this.setState({
          facebook: {
            clicked: false,
            name: responseJson.fullname,
            accessToken: res.accessToken || null
          }
        });
      }
    }
  }

  public async handleFacebookContinueAsClick(e: any) {
    e.preventDefault();
    const facebook = {
      name: this.state.facebook.name,
      accessToken: this.state.facebook.accessToken,
      clicked: true
    };
    this.setState(
      { facebook },
      () => {
        this.handleFacebookCallback({
          accessToken: this.state.facebook.accessToken
        });
      }
    );
  }

  public async handleGoogleCallback(res) {
    // console.log(res)
    // console.log(res.accessToken)
    const accessToken = res.accessToken;
    const responseJson = await this.AuthService.authWithGoogle(accessToken);
    const newRes = cloneDeep(responseJson);
    delete newRes.events;
    this.props.dispatch(UserDucks.setUser(responseJson));
    // Removing old cookies
    this.props.cookies.remove("user", { path: "/" });
    this.props.cookies.remove("token", { path: "/" });
    // Putting new cookies
    const date = new Date(); date.setDate(date.getDate() + 7);
    this.props.cookies.set("user", newRes, { path: "/", expires: date });
    this.props.cookies.set("token", newRes.token, { path: "/", expires: date });
  }

  public renderGoogleButton(props) {
    return (
      <button
        role="facebook"
        className="btn-google"
        onClick={props.onClick}
        style={{ border: 'none' }}
      >
        Login with Google
      </button>
    );
  }

  public render() {

    if (this.props.isLoggedIn) {
      return <Redirect to="/manage/events" />;
    }

    const error = this.state.error === true
      ?
      <div>
        <br />
        <Error content={"Invalid Login Credentials"} />
      </div>
      : null

    const login = (
      <DataValidator
        rules={{
          email: yup
            .string()
            .required()
            .email(),
          password: yup
            .string()
            .required()
            .min(8)
        }}
        data={{
          email: this.state.password.username,
          password: this.state.password.password
        }}
        isValid={valid => this.setState({ isValid: valid })}
      >
        <div className="login-div">
          <form
            className={Padding.small + " pt-3 pl-3 pr-3"}
            onSubmit={this.handleSubmit}
          >
            {this.props.isLoading ? (
              <div className="p-3 w-100 text-center">
                <ClipLoader color={"#000000"} loading={true} />
              </div>
            ) : (
                <React.Fragment>
                  <p><br /></p>
                  <h2 className="text-center w-100 mb-3" style={{ color: '#020102' }}>Backstage</h2>
                  <input
                    type="email"
                    name="username"
                    value={this.state.password.username}
                    onChange={this.handleChangeInput}
                    placeholder="Email address"
                    className="form-control mb-2"
                    required={true}
                  />
                  <input
                    type="password"
                    name="password"
                    value={this.state.password.password}
                    onChange={this.handleChangeInput}
                    placeholder="Password"
                    className="form-control mb-4"
                    required={true}
                  />
                  <div className="login-button-div">
                    <button
                      role="submit"
                      type="submit"
                      className="new-button-blue-gradient"
                    >
                      Login
                    </button>
                    <p />
                    <button className="button_link" onClick={this.forgotPassword}>Forgot your password?</button>
                    <p />
                    {error}
                  </div>
                  <div className={Padding.small + " pl-3 pr-3"}>
                    <div className="login-button-div">
                      <GoogleLogin
                        clientId="518192388634-kak968s7qbfqnlhip3mdo40s85cae7ip.apps.googleusercontent.com"
                        buttonText="Google"
                        onSuccess={this.handleGoogleCallback}
                        onFailure={this.handleGoogleCallback}
                        render={this.renderGoogleButton}
                      />
                      <p />
                    </div>
                    <div className="login-button-div">
                      {!this.state.facebook.name ? (
                        <FacebookLogin
                          appId="249331195705958"
                          fields="id,name,email"
                          autoLoad={false}
                          callback={this.handleFacebookCallback}
                          onFailure={e => console.error(e)}
                          buttonStyle={{
                            lineHeight: 1.5,
                            textTransform: "none",
                            fontFamily: "Rubik",
                            padding: "0.5rem 1rem",
                            width: "200px",
                            height: "40px",
                            borderRadius: "12px",
                            backgroundColor: "#fff",
                            fontSize: "15px",
                            fontStyle: 'bold',
                            fontWeight: 'bold',
                            textAlign: "center",
                            color: "#4d5adf",
                            margin: "auto",
                            border: '4px solid #4d5ad4'
                          }}
                          textButton="Login with Facebook"
                          disableMobileRedirect={true}
                        />
                      ) : (
                          <button
                            role="submit"
                            type="submit"
                            onClick={this.handleFacebookContinueAsClick}
                            style={{
                              lineHeight: 1.5,
                              textTransform: "none",
                              fontFamily: "Rubik",
                              padding: "0.5rem 1rem",
                              width: "200px",
                              fontStyle: 'bold',
                              fontWeight: 'bold',
                              minHeight: "40px",
                              height: 'auto',
                              borderRadius: "12px",
                              backgroundColor: "#fff",
                              fontSize: "15px",
                              textAlign: "center",
                              color: "#4d5adf",
                              margin: "auto",
                              border: '4px solid #4d5ad4'
                            }}
                          >
                            <ReactCSSTransitionGroup {...defaultLoadTransition}>
                              <span>Continue as {this.state.facebook.name}</span>
                            </ReactCSSTransitionGroup>
                          </button>
                        )}
                      <p />
                    </div>
                  </div>
                </React.Fragment>
              )}
          </form>
        </div>
      </DataValidator>
    )

    return (
      <React.Fragment>
        <Card>
          <React.Fragment>
            <div className={'logincard'} style={{ textAlign: 'center', justifyContent: 'center', width: '100%', minWidth: '0px' }}>
              <div>
                <p style={{ width: '100%' }} />
                <img src={require('./Dark-logo.png')} width='35%' />
              </div>
            </div>
            {this.state.changePassword === false ? login : <ForgotPasswordForm />}
          </React.Fragment>
          <p />
        </Card>
      </React.Fragment>
    );
  }

  private setLoading(e: any | boolean) {
    this.props.dispatch(
      UserDucks.setLoading(e === true || e === false ? e : true)
    );
  }

}

const mapStateToProps = state => {
  return {
    isLoading: UserDucks.isLoading(state),
    isLoggedIn: UserDucks.isAuthenticated(state)
  };
};

const x = withCookies(LoginForm)
export default connect(mapStateToProps)(x);



// WEBPACK FOOTER //
// ./src/pages/auth/login/components/login-form/LoginForm.tsx